// AUTO-GENERATED — DO NOT EDIT THIS FILE DIRECTLY.
//
// Synced from useAdminFetch.js
// by scripts/sync_wallet_app.sh on 2026-07-17T08:09:17Z.
//
// To make changes:
//   1. Edit react/_shared/wallet-app/useAdminFetch.js
//   2. Run ./scripts/sync_wallet_app.sh
//
// Editing this copy in place will be overwritten on next sync.
//
// ---------------------------------------------------------------

// useAdminFetch.js
//
// JWT-attaching fetch wrapper for the Bankcoin customer apps. The "admin"
// name is a legacy carry-over from deposit-admin/api.ts where the same
// pattern was named adminFetch — for the customer apps it's just "auth-
// aware fetch". We keep the name so the cross-codebase pattern is greppable.

import { useCallback } from 'react';
import { apiCall } from './api/client';
import { getToken, onUnauthorized } from './useAuthToken';

/**
 * Returns a memoised fetch function bound to the current auth token.
 *
 * Usage:
 *   const adminFetch = useAdminFetch();
 *   const res = await adminFetch('/mint/buy', {
 *     method: 'POST',
 *     body: JSON.stringify(payload),
 *   });
 *   if (res.unavailable) ...
 *   if (!res.ok)         ...
 *   const data = res.data;
 */
export function useAdminFetch() {
  return useCallback(async (path, options = {}) => {
    const token = getToken();
    const res = await apiCall(path, options, token);
    if (res.status === 401) {
      onUnauthorized();
    }
    return res;
  }, []);
}

// Non-hook variant for use outside React (e.g. in module-level utilities).
export async function adminFetch(path, options = {}) {
  const token = getToken();
  const res = await apiCall(path, options, token);
  if (res.status === 401) {
    onUnauthorized();
  }
  return res;
}
